export function noRecursion(func: () => void): () => void {
  let isInProgress = false;
  return (): void => {
    if (isInProgress) return;
    isInProgress = true;
    try {
      func();
    } finally {
      isInProgress = false;
    }
  };
}

export function noRecursionScope(): (func: () => void) => void {
  let isInProgress = false;
  return (func: () => void): void => {
    if (isInProgress) return;
    isInProgress = true;
    try {
      func();
    } finally {
      isInProgress = false;
    }
  };
}
